import React, { useRef } from 'react';
import PropTypes from 'prop-types';

import styles from './VpVideoPlayer.module.less';

// TODO - add custom video player styles at some point
export const VpVideoPlayer = ({ mediaUrl, onLoad, thumbnailUrl }) => {
  const videoPlayerRef = useRef(null);

  const handleOnLoad = () => {
    onLoad && onLoad();
  };

  return (
    <section className={styles.vpVideoContainer}>
      <video
        ref={videoPlayerRef}
        onLoadedData={handleOnLoad}
        autoPlay={false}
        controls
        muted={false}
        {...(thumbnailUrl ? { poster: thumbnailUrl } : {})}
      >
        <source src={mediaUrl} key={mediaUrl} />
      </video>
    </section>
  );
};

VpVideoPlayer.propTypes = {
  mediaUrl: PropTypes.string,
  onLoad: PropTypes.func,
  thumbnailUrl: PropTypes.string
};

export default VpVideoPlayer;



// WEBPACK FOOTER //
// ./src/vp-ui/components/VpVideoPlayer/VpVideoPlayer.jsx